import { lazy as reactLazy } from 'react';
const lazy = (lazyComponent) =>
  reactLazy(() => {
    return new Promise((resolve, reject) =>
      lazyComponent()
        .then((component) => resolve(component))
        .catch((err) => {
          if (err?.name === 'ChunkLoadError') {
            window.location.reload();
          } else {
            reject(err);
          }
        })
    );
  });

export default lazy;
